function e(){return typeof window=="undefined"||typeof document=="undefined"}export{e as isServer};
